import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { useApi } from '../../../../hooks'
import { GretaAIChatStatus } from '../../GretaAIChat.constants'
import { getMockGretaAIChatProjects } from '../../GretaAIChat.mocks'
import { getGretaAIChatErrorStatus } from '../../GretaAIChat.utils'
import { getGretaAIChatProjectChatIds } from '../../GretaAIChat.utils.projects'

import {
  getGretaAIChatProjectsWithChats,
  mapGretaAIChatProjects,
} from './useGretaAIChatProjects.utils'

export function useGretaAIChatProjects({
  chats = EMPTY_LIST,
  isOpen = false,
} = EMPTY_OBJECT) {
  const [projects, setProjects] = useState(EMPTY_LIST)
  const [projectsStatus, setProjectsStatus] = useState(
    GretaAIChatStatus.Loading
  )

  const hasLoadedRef = useRef(false)

  const projectsApi = useApi()

  // TODO: read the projects from the projects endpoint once the backend serves it (IU-1835).
  async function fetchProjects({ options }) {
    setProjectsStatus(GretaAIChatStatus.Loading)

    try {
      const response = await getMockGretaAIChatProjects({ options })

      if (response) {
        setProjects(mapGretaAIChatProjects(response))
        setProjectsStatus(GretaAIChatStatus.Idle)
      }
    } catch (reason) {
      const errorStatus = await getGretaAIChatErrorStatus(reason)

      if (!options?.signal?.aborted) {
        setProjectsStatus(errorStatus)
      }
    }
  }

  function loadProjects() {
    projectsApi.call(fetchProjects)
  }

  useEffect(() => {
    if (isOpen && !hasLoadedRef.current) {
      hasLoadedRef.current = true
      loadProjects()
    }
  }, [isOpen])

  return {
    loadProjects,
    projectChatIds: getGretaAIChatProjectChatIds(projects),
    projects: getGretaAIChatProjectsWithChats(projects, chats),
    projectsStatus,
  }
}
